import styled, { css } from "styled-components";

interface RawInputProps {
  error?: boolean;
  borderShadow?: boolean;
  width?: string | number;
  padding?: string;
  fontSize?: string;
  lineHeight?: string | number;
  endIcon?: boolean;
}

export const RawInput = styled.input.attrs(p => ({
  type: p.type || "text",
}))<RawInputProps>`
  display: block;
  width: ${p => p.width || "100%"};
  padding: ${p => p.padding || (p.endIcon ? "0.65rem 3rem 0.65rem 0.75rem" : "0.65rem 0.75rem")};
  font-size: ${p => p.fontSize || "1rem"};
  line-height: ${p => p.lineHeight || 1.5};
  color: ${p => p.theme.colors.text.primary};
  background-color: ${p => p.theme.colors.background.paper};
  background-clip: padding-box;
  border: 1px solid ${p => p.theme.colors.grey[500]};
  border-radius: ${p => p.theme.borderRadius};
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  :-webkit-autofill {
    box-shadow: 0 0 0 30px ${p => p.theme.colors.background.paper} inset !important;
  }
  ::placeholder {
    color: ${p => p.theme.colors.grey[600]};
  }
  &:focus {
    border-color: ${p => p.theme.colors.primary.main};
    outline: 0;
    ${p => p.borderShadow && `box-shadow: 0 0 0.3rem 0.05rem ${p.theme.colors.primary.main};`}
    & + label {
      color: ${p => (p.error ? p.theme.colors.error.main : p.theme.colors.primary.main)};
    }
  }
  &:disabled {
    color: ${p => p.theme.colors.action.disabled};
    border-color: ${p => p.theme.colors.action.disabled};
    ::placeholder {
      color: ${p => p.theme.colors.action.disabled};
    }
    & + label {
      color: ${p => p.theme.colors.action.disabled};
      cursor: default;
    }
  }
  ${p =>
    p.error &&
    css`
      border-color: ${p.theme.colors.error.main};
      &:focus {
        border-color: ${p.theme.colors.error.main};
        ${p.borderShadow && `box-shadow: 0 0 0.3rem 0.05rem ${p.theme.colors.error.main};`}
      }
      & + label {
        color: ${p => p.theme.colors.error.main};
      }
    `}

  &:focus, &:not(:placeholder-shown), &:-webkit-autofill {
    & + label {
      transform: translateY(-50%);
      font-size: 0.75rem;
      background-color: ${p => p.theme.colors.background.paper};
    }
  }
`;

export const InputLabel = styled.label`
  position: absolute;
  left: 1rem;
  top: 0;
  transform: translateY(70%);
  text-transform: capitalize;
  font-size: 1rem;
  color: ${p => p.theme.colors.grey[600]};
  transition: transform 0.2s, font-size 0.2s, color 0.2s;
  padding: 0 0.25rem;
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
`;
